import { InMemoryCache } from '@apollo/client';

const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        listBooks: {
          keyArgs: ['searchString', 'myAds', 'productId', 'userId'],
          merge(existing, incoming, { args: { pagination = {} } }) {
            const merged = existing ? existing.slice(0) : [];
            const offset = pagination?.offset || 0;

            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < incoming.length; ++i) {
              merged[offset + i] = incoming[i];
            }

            return merged;
          },
        },
        listProducts: {
          keyArgs: ['searchString', 'pagination', ['limit']],
          merge(existing, incoming, { args: { pagination = {} } }) {
            const merged = existing ? existing.slice(0) : [];
            const offset = pagination?.offset || 0;

            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < incoming.length; ++i) {
              merged[offset + i] = incoming[i];
            }

            return merged;
          },
        },
      },
    },
  },
});

export default cache;
